import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    updateSwimmingPool,
    getSwimmingPoolDataWithId,
    getPoolType,
} from "adminApi/SwimminPoolApi/SwimminPoolApi";
import { validateForm } from "utils/validation";
import { SwimmingPoolRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/SwimmingPoolFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";
import EditSwimmingPoolForm from "./Components/EditSwimmingPoolForm";

const EditSwimmingPool = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, SwimmingPoolRules);

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getSwimmingPoolDataWithId, setValues);

    // Fetch pool types for dropdown — belongs in parent, not in form component
    const { data: poolTypeOptions, loading: loadingPoolType } = useFetchAllData(getPoolType);

    // Form submit hook
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await updateSwimmingPool({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, SwimmingPoolRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Swimming Pool updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit || loadingPoolType) && <Spinner isSpinner={true} />}
            <EditSwimmingPoolForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                poolTypeOptions={poolTypeOptions}
            />
        </>
    );
};

export default EditSwimmingPool;
